import styled from 'styled-components';

export const Divider = styled.div`
    display: block;
    width: 100%;
    height: 1px;
    background: var(--container-border-color-100);
    ${({blank}) => {
        if (blank)
            return `
            border: none;
            height: 0px;
        `;
    }}
`;
